import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { QcsChip } from '../common/basic/QcsChip';
import { ApiClientStatus } from '@api/models/enums/ApiClientStatus';

const STATUS_COLORS: Record<ApiClientStatus, 'success' | 'default'> = {
  [ApiClientStatus.Active]: 'success',
  [ApiClientStatus.Inactive]: 'default',
};

export const IntegrationStatusChip: FC<{ status: ApiClientStatus }> = ({ status }) => {
  const { t } = useTranslation();

  return <QcsChip label={t(`integration.apiAccess.status.${status}`)} color={STATUS_COLORS[status]} />;
};
